import type { SupabaseClient } from "@supabase/supabase-js";

export const deleteViewingParticipant = async (
  supabase: SupabaseClient,
  userId: number,
  viewingSlotId: number,
) => {
  return supabase
    .from("viewing_participants")
    .delete()
    .eq("user_id", userId)
    .eq("viewing_slot_id", viewingSlotId);
};
